<template>
  <div class="row-box">
    <BankDetails :data="data[bankDetailsName] || {}" />

    <WrapperField
      v-for="(fieldValue, fieldName) in orderedServiceDetails"
      :key="fieldValue + fieldName + Math.random()"
      :data="
        createDataField({
          fieldName,
          fieldValue,
          fieldGroup: serviceDetailsName,
        })
      "
    />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';

import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import BankDetails from '@/components/elements/statement/FullStatementView/elements/BankDetails';
import { StatementType } from '@/types/services';
import { FieldName } from '@/constants';

const BankDetailsName = {
  ACCOUNT: 'accountBankDetails',
  APPLICANT_ACCOUNT: 'applicantAccountBankDetails',
};

const statementTypeToBankDetailsName = {
  [StatementType.NOTICE_RECOVERY]: BankDetailsName.ACCOUNT,
  [StatementType.RUZDI]: BankDetailsName.ACCOUNT,
  [StatementType.SECURING_EVIDENCE]: BankDetailsName.ACCOUNT,
  [StatementType.ACCEPTANCE_DEPOSIT]: BankDetailsName.APPLICANT_ACCOUNT,
  [StatementType.TRANSFER_EL_DOCS]: BankDetailsName.ACCOUNT,
  [StatementType.CORRECT_TRANSLATION]: BankDetailsName.ACCOUNT,
  [StatementType.ACCEPTANCE_ESCROW]: BankDetailsName.APPLICANT_ACCOUNT,
  [StatementType.STORAGE_ACCEPT]: BankDetailsName.ACCOUNT,
  [StatementType.STORAGE_ISSUE]: BankDetailsName.ACCOUNT,
  [StatementType.DOCUMENT_CONVERSION]: BankDetailsName.ACCOUNT,
  [StatementType.EXTRACTION_ROD]: BankDetailsName.ACCOUNT,
  [StatementType.EGRN_CONFIRM]: BankDetailsName.ACCOUNT,
};

const statementTypeToServiceDetailsName = {
  [StatementType.NOTICE_RECOVERY]:
    FieldGroup.EXECUTIVE_NOTICES_RECOVERY_DETAILS,
  [StatementType.RUZDI]: FieldGroup.RUZDI_DETAILS,
  [StatementType.SECURING_EVIDENCE]: FieldGroup.SECURITY_EVIDENCE_DETAILS,
  [StatementType.ACCEPTANCE_DEPOSIT]: FieldGroup.ACCEPTANCE_DEPOSIT_DETAILS,
  [StatementType.TRANSFER_EL_DOCS]: FieldGroup.TRANSFER_EL_DOCS_DETAILS,
  [StatementType.CORRECT_TRANSLATION]: FieldGroup.CORRECT_TRANSLATION_DETAILS,
  [StatementType.ACCEPTANCE_ESCROW]: FieldGroup.ACCEPTANCE_ESCROW_DETAILS,
  [StatementType.STORAGE_ACCEPT]: FieldGroup.STORAGE_ACCEPT_DETAILS,
  [StatementType.STORAGE_ISSUE]: FieldGroup.STORAGE_ISSUE_DETAILS,
  [StatementType.DOCUMENT_CONVERSION]: FieldGroup.DOCUMENT_CONVERSION_DETAILS,
  [StatementType.EXTRACTION_ROD]: FieldGroup.EXTRACTION_ROD_DETAILS,
  [StatementType.EGRN_CONFIRM]: FieldGroup.EGRN_CONFIRM_DETAILS,
};

const DEFAULT_SERVICE_DETAILS_ORDER = [
  FieldName.CommonServiceDetailsField.HAS_PRIVILEGE,
  FieldName.CommonServiceDetailsField.NOTE,
];

const statementTypeToServiceDetailsOrder = {
  [StatementType.NOTICE_RECOVERY]: [
    ...DEFAULT_SERVICE_DETAILS_ORDER,
    FieldName.executiveNoticesRecoveryDetails.FSSP_SUBDIVISION,
    FieldName.CommonServiceDetailsField.HAS_ANNOUNCEMENT
  ],
  [StatementType.RUZDI]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.SECURING_EVIDENCE]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.ACCEPTANCE_DEPOSIT]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.TRANSFER_EL_DOCS]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.CORRECT_TRANSLATION]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.ACCEPTANCE_ESCROW]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.STORAGE_ACCEPT]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.STORAGE_ISSUE]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.DOCUMENT_CONVERSION]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.EXTRACTION_ROD]: DEFAULT_SERVICE_DETAILS_ORDER,
  [StatementType.EGRN_CONFIRM]: DEFAULT_SERVICE_DETAILS_ORDER,
};

export default {
  name: 'StepRequisites',
  components: {
    WrapperField,
    BankDetails,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    FieldGroup,
    createDataField,
  }),
  computed: {
    bankDetailsName() {
      return statementTypeToBankDetailsName[this.statementType];
    },

    serviceDetailsName() {
      return statementTypeToServiceDetailsName[this.statementType];
    },

    serviceDetails() {
      const data = cloneDeep(this.data);

      delete data[this.serviceDetailsName];

      return data;
    },

    serviceDetailsOrder() {
      return statementTypeToServiceDetailsOrder[this.statementType];
    },

    orderedServiceDetails() {
      const details = {};

      this.serviceDetailsOrder.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.serviceDetails, key)) {
          details[key] = this.serviceDetails[key];
        }
      });

      return details;
    },
  },
};
</script>
